import bootbox from 'bootbox';

$(document).ready(function ($) {
    deleteSectionFromDB()
    deleteFieldFromDB()
});

// Delete Section from DB and view
function deleteSectionFromDB() {
    $('body').on('click', '.deleteSection', function (e) {
        e.preventDefault();

        let section = $(this).parents('.fieldsSection'),
            $fields = section.find('.section-field-container');

        if($fields.length){
            bootbox.alert("Section cannot be removed if it contains at least one field.");
            return;
        }

        if (typeof section.data('section-id') != 'undefined' && section.data('section-id') != '') {
            let data = {
                secID: section.data('section-id'),
                _token: $('[name="csrf-token"]').prop('content'),
            }

            bootbox.confirm({
                message: "Do you really want to delete this section?",
                buttons: {
                    confirm: {
                        label: 'Yes',
                        className: 'btn-primary'
                    },
                    cancel: {
                        label: 'No',
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        $.ajax({
                            url: '/tablebuilder/section/' + data.secID,
                            type: 'DELETE',
                            data: data,
                            success: function (data) {
                                if (data.deleted) {
                                    section.remove()
                                    toastr.success(data.message)
                                } else if (data.field_data) {
                                    bootbox.alert("Section cannot be removed because fields contains data.");
                                }
                            },
                            error: function (xhr, status, error) {
                                let res = xhr.responseText
                                console.log(res)
                            }
                        });
                    }
                }
            });
        } else {
            section.remove()
            $('.propertiesContent').html('')
            $('.propertiesTabHeader, .propertiesContent').hide()
            $('.fieldsContent').show()
        }
    })
}

// Delete Field from DB
function deleteFieldFromDB() {

    $('body').on('click', '.deleteField', function (e) {

        e.preventDefault();

        let section = $(this).parents('.fieldsSection');
        let fieldContainer = $(this).parents('.section-field-container');
        let input = fieldContainer.find('.fieldItem');
        let fieldID = input.data('id');
        let fieldName = input.data('name');
        if (typeof section.data('section-id') != 'undefined' &&
            section.data('section-id') != '' &&
            fieldName != '' &&
            fieldID != ''
        ) {
            let data = {
                secID: section.data('section-id'),
                fieldName: fieldName,
                fieldID: fieldID,
                _token: $('[name="csrf-token"]').prop('content'),
            };

            bootbox.confirm({
                message: translation.confirm_delete,
                buttons: {
                    confirm: {
                        label: translation.yes,
                        className: 'btn-primary'
                    },
                    cancel: {
                        label: translation.no,
                        className: 'btn-danger'
                    }
                },
                callback: function (result) {
                    if (result) {
                        fieldCanBeDeleted(data, fieldContainer);
                    }
                }
            });
        } else {
            fieldContainer.remove()
        }
    })

}

function fieldCanBeDeleted(data, fieldContainer) {
    $.ajax({
        url: '/tablebuilder/validate/delete',
        type: 'GET',
        data: data,
        success: function (res) {
            if (res.canDelete) {
                deleteField(data, fieldContainer);
            } else {
                hideField(data, fieldContainer, res.message);
            }
        }
    });
}

function deleteField(data, fieldContainer) {
    $.ajax({
        url: '/tablebuilder/deletefield',
        type: 'POST',
        data: data,
        success: function (data) {

            if (data.deleted) {

                fieldContainer.remove();
                $('.propertiesContent').html('');
                $('.propertiesTabHeader, .propertiesContent').hide();
                $('.fieldsContent').show();

                toastr.success(data.message);
            }
        },
        error: function (xhr, status, error) {
            let res = xhr.responseText
            fieldContainer.remove();
        }
    })
}

function hideField(data, fieldContainer, message) {
    $.ajax({
        url: '/tablebuilder/hide-field',
        type: 'POST',
        data: data,
        success: function (done) {
            if (done) {
                bootbox.alert(message);
                fieldContainer.remove();
                $('.propertiesContent').html('');
                $('.propertiesTabHeader, .propertiesContent').hide();
                $('.fieldsContent').show();
            }
        }
    })
}
